import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../../components/dialog-wrapper/dialog-wrapper.component';
import { TranslationService } from '../../services/translation.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-detailed-skin-analysis',
  standalone: true,
  imports: [CommonModule, DialogWrapperComponent, TranslatePipe],
  templateUrl: './detailed-skin-analysis.component.html',
  styleUrls: ['./detailed-skin-analysis.component.scss'],
})
export class DetailedSkinAnalysisComponent {
  skinData: any;
  severity: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<DetailedSkinAnalysisComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translationService: TranslationService
  ) {
    this.skinData = data.score.analysis[1].parameters;
    this.severity = data.score.analysis[1].severity;
  }

  getMilanianScore(value: number): string {
    if (!value) return '-';
    if (value >= 70 && value <= 100)
      return this.translationService.translate(
        'results.detailedSkinAnalysis.melaninScoreValues.low'
      );
    if (value >= 50 && value < 70)
      return this.translationService.translate(
        'results.detailedSkinAnalysis.melaninScoreValues.medium'
      );
    if (value >= 30 && value < 50)
      return this.translationService.translate(
        'results.detailedSkinAnalysis.melaninScoreValues.high'
      );
    return '-';
  }

  translateCombinedValue(value: string): string {
    if (!value) return '';

    if (value.includes('results.biomarkers.')) {
      const parts = value.split(', ');
      if (parts.length === 2) {
        const percentage = parts[0];
        const translationKey = parts[1];
        const translatedText =
          this.translationService.translate(translationKey);
        return `${percentage}, ${translatedText}`;
      }
    }

    return value;
  }
}
